// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".secondary-light-text[data-v-e1095040] {\n  color: var(--v-primary-lighten3);\n}\n.v-progress-linear[data-v-e1095040] {\n  width: 50%;\n}", ""]);
// Exports
module.exports = exports;
